export default "__VITE_ASSET__CBkERMcr__"